<template>
  <div class="introduction">
    <div class="top_b">
      <div class="container in_nav">
        <div class="row">
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/introduction">公司简介</router-link>
          </div>
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/hope">愿景和价值观</router-link>
          </div>
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/honor">荣誉资质</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="title">
        <p>公司简介</p>
        <aside>Company Profile</aside>
      </div>
      <div class="row in_con">
        <div class="col-sm-6">
          <p>
            北京悦享互联技术有限公司以为客户的数据安全连接和应用智能提供技术保障为使命。 秉承为万物互联、应用智能贡献技术力量。专注于企业互联网数据接入和业务咨询及服务。 核心业务包括：为企事业提供基于移动互联网的IT系统规划和建设，企业分布式IDC数据接入和选点规划， 软硬件设计、系统集成建设等服务。
          </p>

          <p>
            悦享互联致力于提供高可用的数据中心服务、
            安全可信的数据中心防护及高等级的两地三中心容灾服务，并倡导和实施SD-WAN新技术，
            打造具有核心技术、大规模运营能力的网络空间基础设施运营平台。
            悦享互联目前具备全国大多数重要城市数据中心节点，
            拥有超过5TB的带宽总出口，融合了电信、移动、联通三大主流运营商，
            BGP多线接入，拥有丰富的资源，是高性价比的分布式IDC服务提供商。
          </p>

          <p>
            公司具有IDC增值业务许可证、CDN证书、拥有几十项IDC和物联网相关的软件著作权。并多次获得运营商优秀合作伙伴嘉奖。
            悦享互联的业务涵盖传统互联网、移动互联网、NB-IOT、工业物联网、医疗物联网等多个领域；
            已服务的客户包括金融、保险、医疗、运营商、互联网服务商、游戏、电商、门户网站、流媒体、
            云计算、政府机构等。
          </p>

        </div>
        <div class="col-sm-6">
          <img src="../../assets/Introduction_picture01.jpg" alt="">
          <img src="../../assets/Introduction_picture02.jpg" alt="">
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
  }
  .introduction {

  }

  .top_b {
    height: 350px;
    background: url("../../assets/Introduction_banner.png") no-repeat center center;
    background-size: cover;
    position: relative;
    margin-bottom: 100px;
  }

  .in_nav {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -30px;
    background: #fff;
    box-shadow: 1px 2px 20px rgba(0, 0, 0, .3);
    padding: 0px;
  }

  .in_nav a {
    padding: 20px 20px;
    display: block;
    font-size: 20px;
    color: #333;
  }

  .i_active {
    color: #fff !important;
    font-size: 20px;
    background: #ff9900;
  }
  .title {
    margin-bottom: 50px;
    padding-left: 20px;
  }
  .title p {
    color: #ff9900;
    font-size: 4.5rem;
  }
  .title aside {
    color: #999;
    font-size: 2.4rem;
  }
  .in_con p {
    font-size: 1.8rem;
    color: #333;
    text-indent: 30px;
    margin-bottom: 40px;
    line-height: 36px;
  }
  .in_con img {
    margin-bottom: 30px;
  }
  @media (max-width: 768px) {
    .in_nav {
      bottom: -105px;
    }
    .top_b {
      margin-bottom: 150px;
    }
    .title {
      text-align: center;
    }
  }
</style>
